export const GET_TRIMS_BY_PRICING = "GET_TRIMS_BY_PRICING";
export const GET_TRIMS_BY_PRICING_SUCCESS = "GET_TRIMS_BY_PRICING_SUCCESS";
export const GET_TRIMS_BY_PRICING_ERROR = "GET_TRIMS_BY_PRICING_ERROR";

export const SET_TRIMS_FILTER = "SET_TRIMS_FILTER";
export const SET_TRIMS_FILTER_SUCCESS = "SET_TRIMS_FILTER_SUCCESS";
export const SET_TRIMS_FILTER_ERROR = "SET_TRIMS_FILTER_ERROR";
